"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appVersion = void 0;
const version_json_1 = __importDefault(require("./version.json"));
const { appVersion } = version_json_1.default;
exports.appVersion = appVersion;
